module.exports = __webpack_public_path__ + "components/nearest-webcams/static/webcam_placeholder-6253c56a819e21d15d6afd7e89a9f928.png";